<template lang="pug">
  el-autocomplete(
    ref="autoComplete"
    popper-class="my-autocomplete"
    v-model="addressStr"
    placeholder="请输入详细地址内容"
    :fetch-suggestions="searchAddress"
    @select="handleSelect"
  )
    i(
      class="el-icon-edit el-input__icon"
      slot="suffix"
    )
    template(slot-scope="{ item }")
      el-tooltip(
        :content="showContent(item.address)"
        placement="top"
      )
      span(
        class="addr"
        ) {{ item.name }}
        span(v-if="showContent(item.address)") ({{showContent(item.address)}})
</template>
<script>
import { amapLoader } from '@/common/aMapLoader';

export default {
  name: 'AmapSelect',
  props: {
    cityCode: {
      type: String,
      default: '021'
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      addressStr: undefined,
      amapId: `Amap-${new Date().getTime()}`,
      mapInstance: undefined,
      autoInstance: undefined
    };
  },
  watch: {
    cityCode(val) {
      this.mapInstance.setCity(val);
    }
  },
  created() {
    amapLoader().then((AMap) => {
      window.AMap = AMap;
      this.mapInstance = new AMap.Map(this.amapId, {
        resizeEnable: true
      });

      this.autoInstance = new AMap.Autocomplete({
        input: this.$refs.autoComplete
      });

      this.mapInstance.setCity(this.cityCode);
    });
  },
  methods: {
    searchAddress(queryString, cb) {
      if (queryString) {
        this.autoInstance.search(queryString, (status, result) => {
          const { tips } = result;
          cb(tips || []);
        });
      } else {
        cb([]);
      }
    },
    showContent(content) {
      if (Array.isArray(content)) {
        return '';
      }
      return content || '';
    },
    handleSelect(model) {
      const { location } = model;
      this.addressStr = model.name;
      this.$emit('input', [location.lng, location.lat]);
    },
  }
};
</script>
<style lang="less">
  .amap-select {
    position: relative;
    width: 100%;
    height: 300px;
  }

  .amap-select__control {
    position: absolute;
    z-index: 99;
    top: 10px;
    right: 10px;
  }

  .my-autocomplete {
    li {
      line-height: normal;
      padding: 7px;

      .name {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .addr {
        font-size: 12px;
        color: #b4b4b4;
      }

      .highlighted .addr {
        color: #ddd;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AmapSelector/index.vue?439adcd2